import { render, staticRenderFns } from "./PartnerApproval.vue?vue&type=template&id=97870f26"
import script from "./PartnerApproval.vue?vue&type=script&lang=js"
export * from "./PartnerApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports